const HOME_SCROLL_ENUM = {
  INVESTOR: "investor",
  WHY_WORTH: "whyWorth",
  PRICE: "price",
  CONTACT: "contact",
}

export { HOME_SCROLL_ENUM };